var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { BasicButton, getButtonColors, getButtonSize } from '../styled';
export const BaseInfoButton = css `
  ${BasicButton};
  ${getButtonColors('Tertiary')};
  ${(props) => getButtonSize(props.size)};
`;
export const TertiaryButtonLink = styled(Link) `
  ${BaseInfoButton};
`;
export const TertiaryButtonExternalLink = styled.a `
  ${BaseInfoButton};
`;
const Tertiary = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return props.external ? (React.createElement(TertiaryButtonExternalLink, Object.assign({ href: props.url, size: props.size }, props.buttonProps, { "data-testid": props['data-testid'] }), children)) : (React.createElement(TertiaryButtonLink, Object.assign({ to: props.url, size: props.size }, props.buttonProps, { "data-testid": props['data-testid'] }), children));
};
Tertiary.defaultProps = {
    size: 'Standard',
    external: false,
};
export default Tertiary;
